__turbopack_context__.v({
  "grid": "AvailableLoadsGrid-module-scss-module__IdBnnG__grid",
  "gridItem": "AvailableLoadsGrid-module-scss-module__IdBnnG__gridItem",
  "nudgeSlot": "AvailableLoadsGrid-module-scss-module__IdBnnG__nudgeSlot",
});
